import { CustomFieldType } from 'src/api/generated';

export const formatCustomFieldType = (
  fieldType: CustomFieldType,
  includeTime = false
): string => {
  switch (fieldType) {
    case CustomFieldType.STRING:
      return 'Texto';
    case CustomFieldType.NUMBER:
      return 'Número';
    case CustomFieldType.DATE:
      return includeTime ? 'Fecha y hora' : 'Fecha';
    case CustomFieldType.BOOLEAN:
      return 'Sí/No';
    case CustomFieldType.LIST:
      return 'Lista';
    case CustomFieldType.FILE:
      return 'Archivo';
    default:
      return fieldType;
  }
};

export const getCustomFieldTypeOptions = () => [
  { value: CustomFieldType.STRING, content: 'Texto' },
  { value: CustomFieldType.NUMBER, content: 'Número' },
  { value: CustomFieldType.DATE, content: 'Fecha' },
  { value: CustomFieldType.BOOLEAN, content: 'Sí/No' },
  { value: CustomFieldType.LIST, content: 'Lista' },
  { value: CustomFieldType.FILE, content: 'Archivo' },
];

export const validateFieldKey = (fieldKey: string): string | null => {
  if (!fieldKey) {
    // TODO: check when implementing i18n
    return 'El identificador del campo es requerido';
  }

  if (!/^[a-zA-Z][a-zA-Z0-9_]*$/.test(fieldKey)) {
    // TODO: check when implementing i18n
    return 'El identificador debe empezar con una letra y solo contener letras, números y guiones bajos';
  }

  if (fieldKey.length > 50) {
    // TODO: check when implementing i18n
    return 'El identificador no puede tener más de 50 caracteres';
  }

  return null;
};
